<template>
  <v-container>
    <v-row no-gutters>
      <v-col cols="12" class="bg-lesbian2">
        <v-img
          class="sec-bg-logo"
          src="/assets/img/Logo/logo.png"
          min-width="205"
        ></v-img>

        <v-col class="overflow-y-auto bg-lesbian">
          <div class="preview">
            <PreviewCard
              :name="previewProfile.name"
              :subtitle="previewProfile.subtitle"
              :img="previewProfile.img"
              data="animate__flash animate__delay-1s"
            />
          </div>

          <v-row class="image-gallery">
            <h2>Gallery</h2>
            <v-col v-for="n in 9" :key="n" class="d-flex child-flex" cols="4">
              <v-img
                @click="toggler = !toggler"
                :src="`https://picsum.photos/500/300?image=${n * 5 + 10}`"
                :lazy-src="`https://picsum.photos/10/6?image=${n * 5 + 10}`"
                aspect-ratio="1"
                class="grey lighten-2"
              >
                <template v-slot:placeholder>
                  <v-row
                    class="fill-height ma-0"
                    align="center"
                    justify="center"
                  >
                    <v-progress-circular
                      indeterminate
                      color="grey lighten-5"
                    ></v-progress-circular>
                  </v-row>
                </template>
              </v-img>
            </v-col>
          </v-row>

          <v-container class="mb-16 about-author">
            <div>
              <h3>About Neo James</h3>
              <hr />
              <li>
                <span class="mdi mdi-book-education">Bacholour of Science</span>
              </li>
              <li>
                <span class="mdi mdi-map-marker-multiple"
                  >less than a mile</span
                >
              </li>
              <li><span class="mdi mdi-briefcase"></span> Software Engineer</li>
              <hr />
              <div class="hobbie">
                <v-btn rounded color="primary" dark>Football</v-btn>
                <v-btn rounded color="primary" dark>Gym</v-btn>
                <v-btn rounded color="primary" dark>Swimming</v-btn>
                <v-btn rounded color="primary" dark>Snooker</v-btn>
                <v-btn rounded color="primary" dark>Bowling</v-btn>
              </div>
              <hr />
              <p>
                Lorem ipsum dolor sit amet consectetur adipisicing elit. Rem
                quis, quas laborum doloribus doloremque necessitatibus labore,
                ab maxime eos alias illo repellendus dolorum officia iusto error
                nisi, suscipit placeat eveniet.
              </p>

              <p>
                Lorem ipsum dolor sit amet consectetur adipisicing elit. Rem
                quis, quas laborum doloribus doloremque necessitatibus labore,
                ab maxime eos alias illo repellendus dolorum officia iusto error
                nisi, suscipit placeat eveniet.
              </p>
            </div>
          </v-container>
          <v-col class="text-center action-button-col">
            <v-btn class="mb-5 mx-15" fab dark large @click="nextProfile">
              <span>
                <img class="rejectbtn" src="img/lesbian-icons/reject.png" alt />
              </span>
              <!-- <v-icon dark> mdi-chevron-left </v-icon> -->
            </v-btn>
            <v-btn class="mx-2 mb-5" fab dark large @click="nextProfile">
              <span>
                <img class="nextbtn" src="img/lesbian-icons/date.png" alt />
              </span>
              <!-- <v-icon dark> mdi-chevron-right </v-icon> -->
            </v-btn>
          </v-col>
        </v-col>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
export default {
  data() {
    return {
      profiles: [
        {
          name: "Stuart B.",
          subtitle: "25, Los Angelos",
          description:
            "Lorem ipsum dolor sit amet consectetur adipisicing elit. Consectetur,natus eius fugiat minus quis aperiam laboriosam aliquid suscipit fugit vel dolorem minima. Cumque, explicabo? Eum magnam ullam perferendis doloribus? Eos!",
          img: "https://picsum.photos/id/115/1500/1000",
        },
        {
          name: "Cortney Sa.",
          subtitle: "25, Ontorio",
          description:
            "Lorem ipsum dolor sit amet consectetur adipisicing elit. Consectetur,natus eius fugiat minus quis aperiam laboriosam aliquid suscipit fugit vel dolorem minima. Cumque, explicabo? Eum magnam ullam perferendis doloribus? Eos!",
          img: "https://picsum.photos/id/117/1544/1024",
        },
        {
          name: "John D.",
          subtitle: "25, Texas",
          description:
            "Lorem ipsum dolor sit amet consectetur adipisicing elit. Consectetur,natus eius fugiat minus quis aperiam laboriosam aliquid suscipit fugit vel dolorem minima. Cumque, explicabo? Eum magnam ullam perferendis doloribus? Eos!",
          img: "https://picsum.photos/id/118/1500/1000",
        },
      ],
      previewProfile: {
        name: "Neo James.",
        subtitle: "25, New York",
        description:
          "Lorem ipsum dolor sit amet consectetur adipisicing elit. Consectetur,natus eius fugiat minus quis aperiam laboriosam aliquid suscipit fugit vel dolorem minima. Cumque, explicabo? Eum magnam ullam perferendis doloribus? Eos!",
        img: "https://picsum.photos/id/215/1500/1000",
      },

      images: [
        "https://picsum.photos/500/300?image=15",
        "https://picsum.photos/500/300?image=20",
        "https://picsum.photos/500/300?image=25",
        "https://picsum.photos/500/300?image=30",
        "https://picsum.photos/500/300?image=35",
        "https://picsum.photos/500/300?image=40",
        "https://picsum.photos/500/300?image=45",
        "https://picsum.photos/500/300?image=50",
        "https://picsum.photos/500/300?image=55",
      ],
    };
  },
  computed: {
    checkProfiles() {
      if (this.profiles.length < 3) {
        return this.getProfile();
      }
      if (this.profiles.length < 2) {
        this.getProfile();
        return this.getProfile();
      }

      if (this.profiles.length < 1 || this.profiles.length == 1) {
        this.getProfile();
        this.getProfile();
        return this.getProfile();
      }
    },
  },
  // watch : {
  //   profiles(){
  //     console.log("Watcher Trigger");
  //     if (this.profiles.length < 3) {
  //       return this.getProfile();
  //     }
  //     if (this.profiles.length < 2) {
  //       this.getProfile();
  //       return this.getProfile();
  //     }

  //     if (this.profiles.length < 1 || this.profiles.length == 1) {
  //       this.getProfile();
  //       this.getProfile();
  //       return this.getProfile();
  //     }
  //   }
  // },

  methods: {
    nextProfile: function () {
      // alert('trigger');
      var elem = document.querySelector("div[index='2']");
      //var elemPreview = document.querySelector("div[id='preview']");
      elem.classList.add("animate__animated");
      elem.classList.add("animate__fadeOutLeft");

      //elemPreview.classList.add('animate__fadeOutLeft');
      setTimeout(this.removeProfile, 800);
    },
    getProfile: function () {
      var id = Math.floor(Math.random() * 10);
      this.profiles.unshift({
        name: "John D.",
        subtitle: "32, Los Angelos",
        description:
          "Lorem ipsum dolor sit amet consectetur adipisicing elit. Consectetur,natus eius fugiat minus quis aperiam laboriosam aliquid suscipit fugit vel dolorem minima. Cumque, explicabo? Eum magnam ullam perferendis doloribus? Eos!",
        img: `https://picsum.photos/id/12${id}/1500/1000`,
      });
    },
    removeProfile: function () {
      var lastIndex = this.profiles.length - 1;
      this.previewProfile = this.profiles[lastIndex];
      return this.profiles.pop();
    },
  },
};
</script>
